import { Directive, ElementRef, EventEmitter, Output } from "@angular/core";
import { createPopup, PopupPickerController } from "@picmo/popup-picker";
import emojiData from "emojibase-data/it/data.json";
import messages from "emojibase-data/it/messages.json";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { lightTheme, darkTheme } from "picmo";
import { sntTranslate } from "src/app/support/translate";
import { marker } from "@jsverse/transloco-keys-manager/marker";

interface EmojiData {
  emoji: string;
  hexcode: string;
  label: string;
}

@Directive({
  selector: "[emojiPicker]",
  exportAs: "emojiPicker",
  standalone: false
})
export class EmojiPickerDirective {
  private popupController: PopupPickerController;

  @Output() emoji: EventEmitter<string> = new EventEmitter<string>();

  constructor(bootstrapService: BootstrapService, elementRef: ElementRef) {
    this.popupController = createPopup(
      {
        emojiData,
        messages: <any>messages,
        autoFocus: "search",
        emojiSize: "2rem",
        locale: "it",
        theme:
          bootstrapService.getCurrentTheme() === "light"
            ? lightTheme
            : darkTheme,
        i18n: {
          "categories.activities": sntTranslate(marker("Attività")),
          "categories.animals-nature": sntTranslate(marker("Animali & Natura")),
          "categories.custom": sntTranslate(marker("Personalizzate")),
          "categories.flags": sntTranslate(marker("Bandiere")),
          "categories.food-drink": sntTranslate(marker("Food & Drink")),
          "categories.objects": sntTranslate(marker("Cose")),
          "categories.people-body": sntTranslate(marker("Persone")),
          "categories.recents": sntTranslate(marker("Usate di recente")),
          "categories.smileys-emotion": sntTranslate(marker("Sentimenti")),
          "categories.symbols": sntTranslate(marker("Simboli")),
          "categories.travel-places": sntTranslate(marker("Viaggi & Luoghi")),
          "error.load": sntTranslate(marker("Impossibile caricare le icone")),
          "recents.clear": sntTranslate(marker("Rimuovi le emoji recenti")),
          "recents.none": sntTranslate(
            marker("Non hai selezionato nessuna icona recente")
          ),
          retry: sntTranslate(marker("Riprova")),
          "search.clear": sntTranslate(marker("Pulisci la ricerca")),
          "search.error": sntTranslate(
            marker("Impossibile effettuare la ricerca")
          ),
          "search.notFound": sntTranslate(marker("Nessuna emoji trovata")),
          search: sntTranslate(marker("Cerca fra le emoji"))
        }
      },
      {
        triggerElement: elementRef.nativeElement,
        referenceElement: elementRef.nativeElement,
        position: "bottom-start"
      }
    );

    this.popupController.addEventListener(
      "emoji:select",
      (emojiData: EmojiData) => {
        this.emoji.emit(emojiData.emoji);
      }
    );
  }

  async open(): Promise<void> {
    await this.popupController.open();
  }
}
